// extracted by mini-css-extract-plugin
export default {"containerItem":"style_containerItem__TiO+p"};